/*
 * @Author: gubai
 * @Date: 2021-11-04 13:55:57
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-10-30 15:45:21
 * @Description:
 */
import api from '@/api';
import CONFIG from '@/config';
import { judgeMiniApp } from './index';
function getWxToken(apiList, targetUrl = '') {
    if (!targetUrl) {
        return;
    }
    let url = window.location.href.match(/(^.*\/hy)/)[0] + targetUrl;
    if (url.split('#').length > 1) url = url.split('#')[0];
    api('GET', CONFIG.wxToken, {
        pageUrl: encodeURIComponent(url),
    }).then(({ result }) => {
        wx.ready(() => {
            console.info('wx ready', url);
        });
        wx.config({
            debug: CONFIG.WXDebug,
            appId: result.appId,
            timestamp: result.timeStamp, // 必填，生成签名的时间戳
            nonceStr: result.nonceStr, // 必填，生成签名的随机串
            signature: result.signature, // 必填，签名
            jsApiList: apiList,
            beta: true,
            openTagList: [
                'wx-open-launch-app',
                'wx-open-launch-weapp',
            ],
        });
    });
}

export function initWXConfig(apiList = []) {
    console.info('initWXConfig', window.location.href);
    return new Promise((resolve, reject) => {
        const ua = navigator.userAgent.toLowerCase();
        if (ua.indexOf('micromessenger') > -1) {
            let url = window.location.href;
            if (url.split('#').length > 1) url = url.split('#')[0];
            api('GET', CONFIG.wxToken, {
                pageUrl: encodeURIComponent(url),
            }).then(({ result }) => {
                wx.config({
                    debug: CONFIG.WXDebug,
                    appId: result.appId,
                    timestamp: result.timeStamp, // 必填，生成签名的时间戳
                    nonceStr: result.nonceStr, // 必填，生成签名的随机串
                    signature: result.signature, // 必填，签名
                    jsApiList: apiList,
                    beta: true,
                    openTagList: [
                        'wx-open-launch-app',
                        'wx-open-launch-weapp',
                    ],
                });
                wx.ready(() => {
                    console.info('wx ready', url);
                    resolve();
                });
                wx.error((err) => {
                    console.error('wx error', url);
                    reject(err);
                });
            }).catch(err => {
                reject(err);
            });
        } else {
            resolve();
        }
    });
}

export default function registerWechat(apiList = [], targetUrl = '') {
    judgeMiniApp().then(({ type }) => {
        if (type === 'wechat') {
            getWxToken(apiList, targetUrl);
        }
    }).catch(() => {
        const ua = navigator.userAgent.toLocaleLowerCase();
        if (ua.indexOf('miniprogram') > -1 || ua.indexOf('micromessenger') > -1) {
            getWxToken(apiList, targetUrl);
        }
    }).catch(err => {
        console.log(err);
    });
}
